import axios from "axios";
import md5 from "md5";
import moment from "moment";

export default {
    /**
     * 埋点
     */
    setExecute(data) {
        let execute = {
            "method": "EventTrack",
            "data": data
        }
        let url = window.webConfig.apiPath + '/GenBusCommon/Execute'
        axios.post(url, execute, {
                headers: {
                    token: this.getToken({type: data.type}).token,
                    timestamp: this.getToken({type: data.type}).timestamp,
                }
            }
        ).then(res => {
            console.log('success')
        })
    },
    /**
     * 获取鉴权需要的token和timestamp
     */
    getToken(config) {
        if (config && config.type) {
            let timestamp = moment().format('X') // （大写X）以秒为单位，返回值为字符串类型
            let pageType = config.type
            let str = `[${pageType}]-[${timestamp}]`
            let oldValue = md5(str)
            let newValue = md5(oldValue) // 加密两遍
            let token = btoa(newValue) // 转base64编码
            return {
                token,
                timestamp
            }
        }
    },
    setPointTypeImage(data) {
        let urls = ''
        switch (data) {
            case '疏导点':
                urls = require(`@/assets/mockImages/疏导点.png`)
                break;
            case '管控点':
                urls = require(`@/assets/mockImages/管控点.png`)
                break;
            case '外摆位':
                urls = require(`@/assets/mockImages/外摆位.png`)
                break;
            case '特色集市、夜市':
                urls = require(`@/assets/mockImages/特色集市、夜市.png`)
                break;
        }
        return urls
    },
}